import { NavigatorStep } from './types';

export const NAVIGATOR_STEPS: NavigatorStep[] = ['preview', 'sign', 'download'];
